import { List, ListItem } from '@material-ui/core';
import RecipientDetails from "../RecipientDetails/RecipientDetails";
import React from 'react';
const MissingSignaturesRecipients = _ref => {
  var _relationship$signato;
  let {
    relationship
  } = _ref;
  const {
    email,
    lastName,
    firstName
  } = relationship.buyer;
  const hasPrimarySignatorySigned = relationship.approvalRecord !== null;
  const recipientDetailsItemStyle = {
    display: 'list-item',
    padding: 0
  };
  return /*#__PURE__*/React.createElement(List, {
    style: {
      listStyleType: 'disc',
      marginLeft: '22px'
    }
  }, !hasPrimarySignatorySigned && /*#__PURE__*/React.createElement(ListItem, {
    style: recipientDetailsItemStyle
  }, /*#__PURE__*/React.createElement(RecipientDetails, {
    testid: "send-proposal-approval-reminder-modal-primary-signatory",
    companyName: relationship.customer.name,
    email: email,
    lastName: lastName,
    firstName: firstName
  })), (_relationship$signato = relationship.signatories) === null || _relationship$signato === void 0 ? void 0 : _relationship$signato.map((signatory, index) => {
    const hasSignatorySigned = signatory.approvalRecord !== null;
    return !hasSignatorySigned && /*#__PURE__*/React.createElement(ListItem, {
      key: signatory.id,
      style: recipientDetailsItemStyle
    }, /*#__PURE__*/React.createElement(RecipientDetails, {
      testid: "send-proposal-approval-reminder-modal-signatory-".concat(index),
      key: signatory.id,
      email: signatory.email,
      lastName: signatory.lastName,
      firstName: signatory.firstName
    }));
  }));
};
export default MissingSignaturesRecipients;